export function getPageName(direction) {
  return APP.pageSequence[APP.pageIndex + direction];
}

export function gotoPage(pageName: string) {
  APP.showPage(pageName, { historyHandling: "push" });
}

export function PageButton({
  tabIndex,
  pageName,
  className,
  buttonClassName,
  label,
}: {
  tabIndex?: number;
  pageName: string;
  className: string;
  buttonClassName: string;
  label: string;
}) {
  if (!pageName) {
    return null;
  }
  return (
    <div className={"page-initial-hidden " + className}>
      <button
        tabIndex={tabIndex}
        autoFocus={true}
        className={"fertig-button large font-size-large " + buttonClassName}
        disabled={!APP.isPageJumpable(pageName)}
        aria-label={label}
        data-button-key={pageName}
        onClick={() => {
          APP.logUserAction({ action: "pageButton", pageName }, { stateChange: false });
          APP.showPage(pageName, { historyHandling: "push" });
        }}
      >
        {label}
      </button>
    </div>
  );
}
